
import { Link } from 'react-router-dom';

export default function Footer() {
  const quickLinks = [
    { name: 'Home', href: '/' },
    { name: 'About Us', href: '/about' },
    { name: 'Services', href: '/services' },
    { name: 'Gallery', href: '/gallery' },
    { name: 'Our Doctors', href: '/doctors' },
    { name: 'Contact', href: '/contact' }
  ];

  const services = [
    'Dental Implants',
    'Root Canal Treatment',
    'Cosmetic Dentistry',
    'Orthodontics',
    'Teeth Whitening',
    'Pediatric Dentistry'
  ];

  return (
    <footer className="bg-[#012B53] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {/* Clinic Info */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="mb-4">
              <Link to="/" className="inline-block">
                <img 
                  src="https://static.readdy.ai/image/9921b96583d8c2e46a2d40cbefc3b198/2a288ca5d72d8af29eca8cc51eddb042.jfif" 
                  alt="The Tooth Doctor - Advanced Dental Care Center"
                  className="h-12 sm:h-16 w-auto object-contain"
                />
              </Link>
            </div>
            <p className="text-gray-300 mb-4 text-sm sm:text-base">
              Smile Brighter with Expert Dental Care. Your trusted partner for comprehensive dental health in Thiruverkadu, Chennai.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/toothdoctorofficial1" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-500 transition-colors">
                <i className="ri-facebook-fill text-lg sm:text-xl"></i>
              </a>
              <a href="https://www.instagram.com/toothdoctor_official/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-pink-5 transition-colors">
                <i className="ri-instagram-fill text-lg sm:text-xl"></i>
              </a>
              <a href="https://x.com/ToothdoctorIn" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors">
                <i className="ri-twitter-fill text-lg sm:text-xl"></i>
              </a>
              <a href="https://www.youtube.com/@thetoothdoctorin" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-red-500 transition-colors">
                <i className="ri-youtube-fill text-lg sm:text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="text-gray-300 hover:text-white transition-colors text-sm sm:text-base">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Our Services</h4>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service}>
                  <Link to="/services" className="text-gray-300 hover:text-white transition-colors text-sm sm:text-base">
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="sm:col-span-2 lg:col-span-1">
            <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Contact Us</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-teal-400 mt-1 text-sm sm:text-base"></i>
                <div>
                  <p className="text-gray-300 text-sm sm:text-base">The Tooth Doctor - Advanced Dental Care Centre</p>
                  <p className="text-gray-300 text-sm sm:text-base">No.9/3, First street, Thambu Swamy Nagar</p>
                  <p className="text-gray-300 text-sm sm:text-base">Near Bus Stand, Thiruverkadu, Chennai</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-teal-400 text-sm sm:text-base"></i>
                <div>
                  <a href="tel:+916369090441" className="text-gray-300 hover:text-white transition-colors text-sm sm:text-base">
                    +91 6369090441
                  </a>
                  <br />
                  <a href="tel:+919884885014" className="text-gray-300 hover:text-white transition-colors text-sm sm:text-base">
                    +91 9884885014
                  </a>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-teal-400 text-sm sm:text-base"></i>
                <a href="mailto:toothdoctor.in@gmail.com" className="text-gray-300 hover:text-white transition-colors text-sm sm:text-base">
                  toothdoctor.in@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-6 sm:mt-8 pt-6 sm:pt-8 flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
          <p className="text-gray-400 text-xs sm:text-sm text-center sm:text-left">
            © 2024 The Tooth Doctor. All rights reserved. Website designed and developed by <a href="https://techmejora.com/" target="_blank" rel="noopener noreferrer" className="text-teal-400 hover:text-teal-300 transition-colors">Tech Mejora</a>
          </p>
          <div className="flex items-center space-x-4">
            <Link to="/privacy-policy" className="text-gray-400 hover:text-white text-xs sm:text-sm transition-colors">
              Privacy Policy
            </Link>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white text-xs sm:text-sm transition-colors">
              Website Builder
            </a>
          </div>
        </div>

      </div>
    </footer>
  );
}
